import { render } from "./Marketing.vue?vue&type=template&id=4a8eda5b"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"
script.render = render

export default script